<template>
  <div class="od-card-container margin-bottom-8">
    <div class="odc-header-container">
      <div class="odc-header">
        Hardware Details
      </div>
    </div>
    <div class="odc-body-container">
      <table style="width: 100%">
        <thead>
          <tr>
            <th align="left">
              Item
            </th>
            <th align="left">
              Tracking #
            </th>
            <th align="right">
              Price
            </th>
            <th align="right">
              Qty
            </th>
            <th align="right">
              Total
            </th>
          </tr>
        </thead>
        <tbody v-if="groupedOrderLines">
          <tr
            v-for="(o, idx) in groupedOrderLines"
            :key="idx"
            class="odcb-border-container"
          >
            <td> {{ o.itemName }} </td>
            <td> {{ o.trackingNumber }}</td>
            <td align="right">
              {{ getAmount(o.price) }}
            </td>
            <td align="right">
              {{ o.quantity }}
            </td>
            <td align="right">
              {{ getAmount(o.total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'OrderHardware',
  mixins: [partnerReviewMixin],
  computed: {
    orderLinesWithoutSubs() {
      const orderLinesWithoutSubs = this.order.orderLines.filter((ol) => ol.type.toLowerCase() !== 'subscription');
      return orderLinesWithoutSubs;
    },
    groupedOrderLines() {
      // seperate by sku, then join lists
      const orderLines = this.order.orderLines.filter((ol) => ol.type.toLowerCase() !== 'subscription');
      const groupedBySku = {};
      for (let i = 0; i < orderLines.length; i++) {
        if (orderLines[i].sku && orderLines[i].sku in groupedBySku) {
          const oldlist = groupedBySku[orderLines[i].sku];
          oldlist.push(orderLines[i]);
          groupedBySku[orderLines[i].sku] = oldlist;
        } else if (orderLines[i].sku) {
          const newlist = [];
          newlist.push(orderLines[i]);
          groupedBySku[orderLines[i].sku] = newlist;
        }
      }
      const allGroupList = [];
      for (let i = 0; i < Object.keys(groupedBySku).length; i++) {
        const groupList = groupedBySku[Object.keys(groupedBySku)[i]];
        allGroupList.push(...groupList);
      }
      return allGroupList;
    },
  },
};
</script>
